import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles/index';
import baseStyle from '../../../styles/goal';
import {
    getBooksForStudent,
    getAllBooks,
    deleteBook,
    getStudent,
    toggleBookType,
    toggleEchoType,
    getBookshareRequestedBooks,
    fetchStaffDashboard
} from '../../../redux/actions';
import { toggleBookTypeOptimistic, toggleEchoTypeOptimistic, switchFromEchoToParagraphMode, switchFromParagraphToEchoMode } from '../../../redux/actions/platform/books';
import { connect } from 'react-redux';
import EditWizardButton from '../../components/Wizards/Edit/EditWizardButton';
import WizardToggleButton from '../../components/Wizards/WizardToggleButton';
import ImportBook from '../../components/Student/ImportBook';
import BookShare from '../../components/Student/BookShare';
import {
    Dialog, DialogActions, DialogContent, 
    DialogTitle,
    Button, DialogContentText
} from '@material-ui/core';
import { Paper, IconButton, Typography, Toolbar } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { getStudentProfile, checkStudentProfile, createStudentProfile, patchStudentProfile, resetScore } from '../../../redux/actions';
import { sortedBooks, formatDate } from '../../../helpers';
import { ROOT_URL } from '../../../redux/constants';
import styles from '../../../styles/skillList.js';
import { FormattedMessage } from 'react-intl';
import BrowseBook from '../../components/Student/BrowseBook';
import BookShareRequestUserTable from '../../components/Shared/BookShareRequestUserTable';
import BookCard from './Books/BookCard';

//progress indicator hardcoded constants
const strokeWidth = 10;
const rotation = 0.6;
const circleRatio = 0.8;

class Books extends Component {
    constructor(props) {
        super(props);
        this.state = {
            order: 'asc',
            orderBy: 'status',
            selected: {},
            tested: '',
            editing: false,
            sortedBooks: [], // Single array for all books
            reset: [],
            error: {},
            readingTime: 10,
            firstBookImportModal:false,
            isOpenFromBooksPage: false,
        };
    }

    toggleType = (book) => {
        // Check if we're in Sentence mode with Echo ON and trying to switch to Paragraph
        if (book.wordRate === '-1') {
            // We're in Sentence mode with Echo ON, switching to Paragraph mode
            // Use the specialized action that handles both toggles and sequential API calls
            this.props.switchFromEchoToParagraphMode(this.props.id, book.id, book);
        } else {
            // Normal passage length toggle (no Echo mode complications)
            this.props.toggleBookTypeOptimistic(this.props.id, book.id, book);
        }
    };

    toggleEcho = (book) => {
        // Check if we're in Paragraph mode and trying to turn Echo ON
        if (book.wordRate === '75') {
            // We're in Paragraph mode, switching to Sentence+Echo mode
            // Use the specialized action that handles sequential toggles and API calls
            this.props.switchFromParagraphToEchoMode(this.props.id, book.id, book);
        } else {
            // Normal echo toggle for Sentence mode (either ON→OFF or OFF→ON)
            this.props.toggleEchoTypeOptimistic(this.props.id, book.id, book);
        }
    }

    handleReset = (skill) => {
        if (window.confirm("Are you sure? This will delete all progress and data.")) {
            resetScore(this.props.id, skill.id)
        }
    };
    setIsOpenFromBooksPage = (bool) =>{
        this.setState({ isOpenFromBooksPage: bool });
    }

    componentDidMount() {
        this.props.getStudent(this.props.id);
        this.props.getBooksForStudent(this.props.id);
        this.props.getStudentProfile(this.props.id);
        checkStudentProfile(this.props.id).catch((e) => {
            this.props.createStudentProfile({ studentId: this.props.id, readingTime: 10 });
        })
        this.props.getBookshareRequestedBooks(this.props.id);
        this.props.fetchStaffDashboard(this.props.user.staffId)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.books !== this.props.books) {
            console.log('cwrp nextprops books', nextProps.books);
            const sortedBooksList = sortedBooks(nextProps.books);
            this.setState({ sortedBooks: sortedBooksList });
        }
        if (nextProps.books.length < this.props.books.length) {
            this.props.getAllBooks(this.props.id);
        }
        if (nextProps.studentProfile.readingTime !== this.state.readingTime) {
            nextProps.studentProfile.readingTime && this.setState({ "readingTime": nextProps.studentProfile.readingTime });
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if(prevProps.user !== this.props.user){
            this.props.fetchStaffDashboard(this.props.user.staffId)
        }

        if(prevProps.user !== this.props.user){
            this.props.fetchStaffDashboard(this.props.user.staffId)
        }
        if(this.props.books !== prevProps.books || prevProps.staffDashboard !== this.props.staffDashboard){
            if(this.props.staffDashboard[0]){
            const filteredActiveStudent = this.props.staffDashboard.filter(std => std.activeBook == 'Yes');
            if(this.props.books.length === 1 && prevProps.books.length === 0 && filteredActiveStudent.length===0){
                this.setState({firstBookImportModal:true})
            }}
        }
    }
    saveReadingTarget = (newVal) => {
        let studentProfile = this.props.studentProfile;
        studentProfile.readingTime = newVal;
        if (studentProfile.id && studentProfile.id !== 'null') {
            this.props.patchStudentProfile(studentProfile);
        } else {
            this.props.getStudentProfile(this.props.id);
            setTimeout(() => {
                let studentProfile = this.props.studentProfile;
                studentProfile.readingTime = newVal;
                this.props.patchStudentProfile(studentProfile);
            }, 600)
        }
        this.setState({ "readingTime": newVal });
    }

    componentWillUnmount() {
        this.setState({ reset: [] })
    }

    handleDelete = (book) => {
        const { deleteBook } = this.props;
        deleteBook(this.props.id, book)
    };
    handleModalClose=()=>{
        this.setState({firstBookImportModal:false})
    }
    
    render() {
        const { id, student, bookList, books, bookShareRequestBooks, databank } = this.props;
        const rows = [
            { id: 'name', label: <FormattedMessage id='General.name' /> },
            { id: 'description', label: <FormattedMessage id='General.description' /> },
        ];
        const { classes } = this.props;
        const readingTime = this.state.readingTime;
        const { sortedBooks: sortedBooksArray } = this.state;

        return (
            <>
                {/* Books Grid Section */}
                <Paper className={classes.list}>
                    <Toolbar classes={{ root: classes.toolbar }} style={{ alignItems: 'center', display: 'flex' }}>
                        <Typography 
                            variant="h4" 
                            style={{ 
                                fontWeight: 'normal',
                                fontSize: '1.75rem',
                                color: '#333',
                                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                                marginRight: '24px'
                            }}
                        >
                            Current Books for {this.props.student.firstName} {this.props.student.lastName}
                        </Typography>
                        
                        <div style={{ 
                            display: 'inline-flex', 
                            alignItems: 'center',
                            height: '100%'
                        }}>
                            <div style={{ marginTop: '-20px' }}>
                                <WizardToggleButton
                                    disabled={!databank}
                                    openWizard={this.setIsOpenFromBooksPage}
                                    text={<FormattedMessage id="Databanks.browseStory" />}
                                />
                            </div>
                        </div>
                    </Toolbar>

                    <div style={{ 
                        display: 'flex', 
                        flexWrap: 'wrap', 
                        padding: '16px',
                        justifyContent: 'flex-start',
                        gap: '16px'
                    }}>
                        {sortedBooksArray.map((book, index) => (
                            <BookCard
                                key={book.id}
                                value={book}
                                toggleType={this.toggleType}
                                toggleEcho={this.toggleEcho}
                                handleReset={this.handleReset}
                                handleDelete={this.handleDelete}
                                isDashboardEnabled={student && student.isDashboardEnabled === 'Y'}
                            />
                        ))}
                    </div>
                </Paper>

                <Dialog open={this.state.error.status === 400}>
                    <DialogContent>
                        <DialogContentText>
                            {this.state.error.data}. Please update your subscription in order to use these products
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            color='primary'
                            onClick={() => this.setState({ error: {} })}
                        >
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* <ImportBook title={<FormattedMessage id='Databanks.sampleSkill'/>} history={this.props.history} id={this.props.id}/> */}
                <BrowseBook 
                    title={<FormattedMessage id='Databanks.sampleSkill' />} 
                    history={this.props.history} 
                    id={this.props.id} 
                    isOpenFromBooksPage={this.state.isOpenFromBooksPage} 
                    setIsOpenFromBooksPage={this.setIsOpenFromBooksPage}
                />

                {/* Table at the bottom of Books page that shows requested books */}
                {bookShareRequestBooks && bookShareRequestBooks.data && bookShareRequestBooks.data.length > 0 &&
                    <BookShareRequestUserTable data={bookShareRequestBooks.data}
                        studentId={this.props.id} />}

                {this.state.firstBookImportModal && <Dialog
                    open={this.state.firstBookImportModal}
                    maxWidth='md'
                    fullWidth
                    onClose={this.handleModalClose}
                    PaperProps={{ classes:{ root: classes.container }}}
              >  <DialogTitle className={ classes.dialogTitle }>
                  <Typography className={classes.enrollTitle} variant='h4' style={{ float: 'left' }}>
                  Almost done!</Typography>
                  <IconButton
                    onClick={this.handleModalClose}
                    className={classes.exitIcon}
                    aria-label="close dialog"
                    style={{ float: 'right' }}
                  >
                    <Close />
                  </IconButton>
                </DialogTitle>
                <DialogContent className={classes.dialog}>
                  <div style={{ padding: '50px', paddingTop: '5px' }}>
                    <Typography variant="subtitle1" style={{fontSize:20}}>
                        Great! You've assigned your student a book, now it's time for them to read, which they can do by logging in with their assigned username and password at,
                        <br/><a href={"http://BuddyBooks.ObjectiveEd.com"} target="_blank" rel="noopener noreferrer">BuddyBooks.ObjectiveEd.com</a>
                        </Typography>
                      {/* <Typography variant="subtitle1" style={{fontSize:20}}>Check out our training video on how to use the reading website,<br /></Typography>
                       <iframe
                        title='guide-video'
                        width="640"
                        height="360"
                        src={`//www.youtube.com/embed/Fg5Qk-p_2A8?start=40`}
                        frameBorder='0'
                        allow='accelerometer; autoplay; encrypted-media; gyroscope;'
                        allowFullScreen
                        /> */}
                    <Typography variant="subtitle1" style={{fontSize:20}}><b>Our preferred web-browser:</b> Google Chrome</Typography>
                    <Typography variant="subtitle1" style={{fontSize:20}}><b>Reading Website URL:</b>
                    <a href={"http://BuddyBooks.ObjectiveEd.com"} target="_blank" rel="noopener noreferrer"> BuddyBooks.ObjectiveEd.com</a></Typography>
                    <Typography style={{marginTop:20}}>
                        *Make sure your student enables microphone permissions and sets up their audio settings the first time they go to read.
                    </Typography>
                  </div>
                </DialogContent>
              </Dialog>}
            </>
        )
    }
}


const mapState = ({ platform: { books, bookList, studentProfile, student, bookShareRequestBooks, staffDashboard, databank }, shared: { user } }) => {
    return {
        books,
        bookList,
        student,
        user,
        studentProfile,
        bookShareRequestBooks,
        staffDashboard,
        databank
    }
};

const mapDispatch = (dispatch, { history }) => {
    return {
        getStudent: (id) => dispatch(getStudent(id)),
        deleteBook: (studentId, book) => dispatch(deleteBook(studentId, book)),
        getAllBooks: (studentId) => dispatch(getAllBooks(studentId)),
        getBooksForStudent: (studentId) => dispatch(getBooksForStudent(studentId)),
        createStudentProfile: (studentProfile) => dispatch(createStudentProfile(studentProfile)),
        patchStudentProfile: (studentProfile) => dispatch(patchStudentProfile(studentProfile)),
        toggleBookType: (studentId, storyId) => dispatch(toggleBookType(studentId, storyId)),
        toggleEchoType: (studentId, storyId) => dispatch(toggleEchoType(studentId, storyId)),
        getStudentProfile: (id) => dispatch(getStudentProfile(id)),
        getBookshareRequestedBooks: (id) => dispatch(getBookshareRequestedBooks(id)),
        fetchStaffDashboard: (id) => dispatch(fetchStaffDashboard(id)),
        toggleBookTypeOptimistic: (studentId, storyId, book) => dispatch(toggleBookTypeOptimistic(studentId, storyId, book)),
        toggleEchoTypeOptimistic: (studentId, storyId, book) => dispatch(toggleEchoTypeOptimistic(studentId, storyId, book)),
        switchFromEchoToParagraphMode: (studentId, storyId, book) => dispatch(switchFromEchoToParagraphMode(studentId, storyId, book)),
        switchFromParagraphToEchoMode: (studentId, storyId, book) => dispatch(switchFromParagraphToEchoMode(studentId, storyId, book)),
    }
};

export default withStyles(baseStyle)(connect(mapState, mapDispatch)(Books));